import React from 'react';
import { Small } from '@finect/tabular-core/Small';
import { BubbleWithIcon } from '../../components';
import { Inner } from './partials';
import { ProgressBar, ProgressBarBlock } from './ProgressBar';
export var PillHeader = function PillHeader(_ref) {
  var app = _ref.app,
    pillProps = _ref.pillProps;
  var currentStep = pillProps.pillState.currentIndex + 1;
  var countSteps = app.steps.length;
  return React.createElement(Inner, null, React.createElement("div", null, React.createElement(BubbleWithIcon, {
    type: "edit",
    size: "medium"
  })), React.createElement(ProgressBarBlock, null, React.createElement(Small, {
    light: true
  }, "Paso ", currentStep, " de ", countSteps), React.createElement(ProgressBar, {
    currentStep: currentStep,
    steps: countSteps
  })));
};